<template>
  {{ formatted }}
</template>

<script>
import { transitionNumber } from './transition-number'
export default {
  props: ['value', 'thousandth'],
  data() {
    return {
      formatted: ''
    }
  },
  watch: {
    value(newValue, oldValue) {
      const callback = (v) => {
        this.formatted = v
      }
      transitionNumber({
        newValue: newValue,
        oldValue: oldValue,
        duration: 500,
        callback: callback
      })
    }
  },
  created() {
    const callback = (v) => {
      this.formatted = v
    }
    transitionNumber({
      newValue: this.value,
      oldValue: 0,
      duration: 500,
      callback: callback
    })
  }
}
</script>
